/**
 * @title account-details-update.js: Sub-module for Account pages
 * @description This module is used to handle account details tasks
 * @dependency
 */
define(['passwordStrength'], function(passwordStrength) {
  let AccountDetailsUpdatePass = {
    /**
     * Basic initial function. Sets events, form focus and fires the
     * needed validation methods.
     * @return {void}
     */
    init: function() {  
      this.validationRules();
      this.validate();
      this.focusInput();
      passwordStrength.init();
    },
    /**
     * We want to focus the user on the existing password input field
     */
    focusInput: function() {
    	$(window).ready(function() {
    	  $("input[name='logonPasswordOld']").focus();
    	  window.scrollTo(0, 0);
      });
    },
    /**
     * The validation rules for the inputs assoicated new password creation.
     */
    validationRules: function() {
      $.validator.addMethod('passwordRule', function(value, element) {
        return /^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value);
      }, messages.JS_VALID_REQUIRED);
    },
    /**
     * Validate the given forms.
     */
    validate: function() {
        
        $('#ChangePasswordForm').validate({
          rules: {
        	logonPasswordOld: {
        	  required: true,
  	        },
      	  	logonPassword: {
        	  required: true,
  	          passwordRule: true,
  	        },
            logonPasswordVerify: {
              required: true,
              passwordRule: true,
              equalTo: 'input[name="logonPassword"]',
            },
          },
          messages: {
        	logonPasswordOld: {
          	  required: messages.CONFIRM_PASSWORD,
            },
            logonPassword: {
          	  required: messages.CONFIRM_PASSWORD,
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
            },
            logonPasswordVerify: {
              required: messages.CONFIRM_PASSWORD,
              passwordRule: messages.ERR_REQUIRED_PASSWORD,
              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH,
            },
          },
          
          submitHandler: function(form) {
          form.submit();
        }.bind(this),
      });
     },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.AccountDetailsUpdatePass = AccountDetailsUpdatePass;
  return AccountDetailsUpdatePass;
});



// WEBPACK FOOTER //
// ./js/account/account-details-update-pass.js